// 帖子相关的 Action 层，负责业务逻辑和异步操作
import { action, makeObservable } from 'mobx';
import { HouseStore } from './store';
import { houseCertlike, houseCertClaim, readHouseCert, readHouseCertTotal, houseCertGenerate } from '@server/api';


export class HouseAction extends HouseStore {

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    /**
     * 房产证活动点赞
     */
    async houseCertlike(params) {
        const res = await houseCertlike(params);
        return res
    }

    /**
     * 房产证活动点赞
     */
    async houseCertGenerate(params) {
        const res = await houseCertGenerate(params);
        return res
    }
    

    /**
     * 房产证领取
     */
    async houseCertClaim(params) {
        const res = await houseCertClaim(params);
        return res
    }

    /**
     * 获取房产证信息
     */
    async getHouseCert(params) {
        const res = await readHouseCert(params);
        return res
    }

    /**
     * 获取房产证活动统计信息
     */
    async getHouseCertTotal(params) {
        const res = await readHouseCertTotal(params);
        return res
    }

}

// 单例导出，方便全局调用
const houseAction = new HouseAction();
export default houseAction;